import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { systemReducer } from "./system";

import { Auth, System } from "../actions";

// define the entire state into the entire sire
export interface StoreState {
  auth: Auth;
  system: System;
}

export const reducers = combineReducers<StoreState>({
  auth: authReducer,
  system: systemReducer,
});
